import { Button, Spinner } from '@patternfly/react-core'

const LoadingButton = () => (
  <Button variant='control' className='pf-v5-u-m-sm'>
    <Spinner className='pf-v5-u-ml-lg pf-v5-u-mr-lg' size='md' aria-label='Loading' />
  </Button>
)
export default LoadingButton
